// merchinsupplier.jsx
import React, { useState, useEffect } from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  List, 
  ListItem, 
  ListItemText, 
  CircularProgress, 
  Box, 
  Typography 
} from '@mui/material';
import DarEntradaModal from './DarEntradaModals';
import { getMerchandiseBySupplier, darEntrada } from '../../services/api';

const Merchinsupplier = ({ open, onClose, supplier }) => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [darEntradaOpen, setDarEntradaOpen] = useState(false);
  const [selectedMerchandise, setSelectedMerchandise] = useState(null);

  useEffect(() => {
    if (open && supplier) {
      const fetchArticles = async () => {
        setLoading(true);
        try {
          // Busca os artigos associados ao fornecedor (usando o supplier.id)
          const response = await getMerchandiseBySupplier(supplier.id);
          setArticles(response.data);
        } catch (error) {
          console.error("Erro ao buscar artigos do fornecedor:", error);
        }
        setLoading(false);
      };
      fetchArticles();
    }
  }, [open, supplier]);

  const openDarEntradaModal = (merchandise) => {
    setSelectedMerchandise(merchandise);
    setDarEntradaOpen(true);
  };
  
  const closeDarEntradaModal = () => {
    setDarEntradaOpen(false);
    setSelectedMerchandise(null);
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>
          Artigos do Fornecedor: {supplier ? supplier.name : ''}
        </DialogTitle>
        <DialogContent dividers>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              {articles.length > 0 ? (
                <List>
                  {articles.map((article) => (
                    <ListItem key={article.id} divider>
                      <ListItemText 
                        primary={article.name} 
                        secondary={`Referência: ${article.reference}`} 
                      />
                      <Button 
                        variant="contained" 
                        color="primary" 
                        onClick={() => openDarEntradaModal(article)}
                      >
                        Dar Entrada
                      </Button>
                    </ListItem>
                  ))}
                </List>
              ) : (
                <Typography variant="body2">
                  Nenhum artigo encontrado para este fornecedor.
                </Typography>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Fechar</Button>
        </DialogActions>
      </Dialog>

      {/* Renderiza o modal de Dar Entrada dentro do retorno */}
      {selectedMerchandise && darEntradaOpen && (
        <DarEntradaModal 
          open={darEntradaOpen} 
          onClose={closeDarEntradaModal} 
          merchandise={selectedMerchandise} 
        />
      )}
    </>
  );
};

export default Merchinsupplier;
